import { gql } from '@apollo/client'

export const GET_UNIQUE_PIN_NUMBER = gql`
  query GetUniquePinNumber {
    uniquePinNumber
  }
`
